import { SelectOption } from '@form';
import { FilterConfig } from '../models/filters.models';
import { SelectOptionGroup } from '../../form/models/form.model';

export const DEFAULT_FILTERS: FilterConfig[] = [
  {
    label: 'FILTERS.DEFAULT.WAVE_STATUS',
    value: 'waveStatus',
    type: 'select',
    options: [
      {
        label: 'FILTERS.DEFAULT.APT',
        value: true
      },
      {
        label: 'FILTERS.DEFAULT.NO_APT',
        value: false
      }
    ]
  },
  {
    label: 'FILTERS.DEFAULT.NUM_TRANSFORMERS',
    value: 'numberMachines',
    type: 'number',
  },
  {
    label: 'FILTERS.DEFAULT.OUTPUT_ID',
    value: 'outputId',
    type: 'string',
  },
  {
    label: 'FILTERS.DEFAULT.RSBAT_ID',
    value: 'tsabtId',
    type: 'string',
  },
  {
    label: 'FILTERS.DEFAULT.TRANSFORMER_CURRENT',
    value: 'percentageIntensity',
    condition: 'equals',
    type: 'number',
    min: 0,
    max: 100,
    suffix: '%'
  },
  {
    label: 'FILTERS.DEFAULT.TRANSFORMER_POWER',
    value: 'percentagePower',
    condition: 'equals',
    type: 'number',
    min: 0,
    max: 100,
    suffix: '%'
  },
  {
    label: 'FILTERS.DEFAULT.TEMPERATURE',
    value: 'temperature',
    condition: 'equals',
    type: 'number',
    suffix: 'º',
  },
  {
    label: 'FILTERS.DEFAULT.TIME_UPDATE',
    value: 'updatedAt',
    type: 'date',
    subType: 'range'
  },
];

export const ALARM_CATEGORY_AND_TYPE: any = [
  {
    label: "FILTERS.ALARM_CATEGORY_AND_TYPE.DEVICE.RSABT.CATEGORY.GROUND_LEAKAGE",
    value: "rsabt-groundLeakage",
    deviceType: "rsabt",
    options: [
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.LEAKAGE_CURRENT_DETECTION',
        value: 'rsabt-groundLeakage-leakageCurrentDetection'
      },
    ],
  },
  {
    label: "FILTERS.ALARM_CATEGORY_AND_TYPE.DEVICE.RSABT.CATEGORY.POWER_QUALITY",
    value: "rsabt-powerQuality",
    deviceType: "rsabt",
    options: [
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.CRITIC_FREQUENCY',
        value: 'rsabt-powerQuality-criticFrequency'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.POWER_FAILURE_VOLTAGE',
        value: 'rsabt-powerQuality-powerFailureVoltage'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.VOLTAGE_DROP',
        value: 'rsabt-powerQuality-voltageDrop'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.OVERVOLTAGE',
        value: 'rsabt-powerQuality-overVoltage'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.FREQUENCY',
        value: 'rsabt-powerQuality-frequency'
      },
    ],
  },
  {
    label: "FILTERS.ALARM_CATEGORY_AND_TYPE.DEVICE.TSABT.CATEGORY.BLOWN_FUSE",
    value: "tsabt-blownFuse",
    deviceType: "tsabt",
    options: [
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.NOMINAL_CURRENT_RATING',
        value: 'tsabt-blownFuse-nominalCurrentRating'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.OPEN_FUSE',
        value: 'tsabt-blownFuse-openFuse'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.FUSE_BLOWN_BY_SHORT_CIRCUIT',
        value: 'tsabt-blownFuse-fuseBlownByShortCircuit'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.FUSE_BLOWN_BY_OVERLOAD',
        value: 'tsabt-blownFuse-fuseBlownByOverload'
      },
    ],
  },
  {
    label: "FILTERS.ALARM_CATEGORY_AND_TYPE.DEVICE.VTN.CATEGORY.POWER_QUALITY",
    value: "vtn-powerQuality",
    deviceType: "vtn",
    options: [
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.NEUTRAL_OVERVOLTAGE_LEVEL_1',
        value: 'vtn-powerQuality-neutralOvervoltageLevel1'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.NEUTRAL_OVERVOLTAGE_LEVEL_2',
        value: 'vtn-powerQuality-neutralOvervoltageLevel2'
      },
      {
        label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.TYPE.OVERTEMPERATURE',
        value: 'vtn-powerQuality-overtemperature'
      },
    ],
  },
]

export const EVENT_GROUP_AND_TYPE: any = [
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.STANDARD",
    value: "rsabt-1",
    deviceType: "rsabt",
    options: [
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ALTERNATIVE_POWER_SUPPLY_STARTUP', value: 'rsabt-1-1'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.MAIN_POWER_SUPPLY_STARTUP', value: 'rsabt-1-2'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ALTERNATIVE_POWER_SUPPLY_FAILURE', value: 'rsabt-1-5'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.MAIN_POWER_SUPPLY_FAILURE', value: 'rsabt-1-6'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.LOW_BATTERY', value: 'rsabt-1-7'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PROGRAM_MEMORY_ERROR', value: 'rsabt-1-10'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RAM_MEMORY_ERROR', value: 'rsabt-1-11'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.NV_MEMORY_ERROR', value: 'rsabt-1-12'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.WATCHDOG_ERROR', value: 'rsabt-1-13'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FILE_SYSTEM_ERROR', value: 'rsabt-1-14'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.LOW_LEVEL_FREE_FLASH_MEMORY', value: 'rsabt-1-15'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.BACKUP_COMPLETED', value: 'rsabt-1-16'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.HIGH_TEMPERATURE', value: 'rsabt-1-17'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.HIGH_TEMPERATURE_END_CONDITION', value: 'rsabt-1-18'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RTU_CONFIG_CHANGE', value: 'rsabt-1-19'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RS485_PORT_CONFIG_CHANGE', value: 'rsabt-1-20'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADMIN_MODE_USER_OR_PASS_LOCAL_ACCESS_CHANGE', value: 'rsabt-1-21'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CONSULT_MODE_USER_OR_PASS_LOCAL_ACCESS_CHANGE', value: 'rsabt-1-22'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FTP_REPORT_SENT_USER_OR_PASS_CHANGE', value: 'rsabt-1-23'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GET_FW_RTU_USER_OR_PASS_CHANGE', value: 'rsabt-1-24'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GET_FW_CARD_USER_OR_PASS_CHANGE', value: 'rsabt-1-25'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.STG_ACCESS_PASS_CHANGE', value: 'rsabt-1-26'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RTU_FW_UPDATE', value: 'rsabt-1-27'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VR_NOMINAL_VOLTAGE_CHANGE', value: 'rsabt-1-28'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SYNC_TYPE_CHANGE', value: 'rsabt-1-30'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FW_FTP_CARD_DOWNLOAD_FAILURE', value: 'rsabt-1-32'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FW_FTP_RTU_DOWNLOAD_FAILURE', value: 'rsabt-1-33'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.UPDATE_FW_CARD_PROCESS_END_WITH_FAILURE', value: 'rsabt-1-34'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.UPDATE_FW_RTU_PROCESS_END_WITH_FAILURE', value: 'rsabt-1-35'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FAILED_RECEIVED_REQUEST_FROM_STG', value: 'rsabt-1-36'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FW_CARD_UPDATED', value: 'rsabt-1-37'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CARD_CONFIG_CHANGE', value: 'rsabt-1-38'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_USER_PASSWORD_READ', value: 'rsabt-1-39'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_USER_PASSWORD_MAGAMENENT', value: 'rsabt-1-40'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_USER_PASSWORD_FW', value: 'rsabt-1-41'},
      { label: 'FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RSABT_DATETIME', value: 'rsabt-1-42'},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.ACCESS",
    value: "rsabt-2",
    deviceType: "rsabt",
    options: [
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADMIN_MODE_USER_ACCESS_RSABT_REMOTE", value: "rsabt-2-1"},
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADMIN_MODE_USER_ACCESS_RSABT_END_REMOTE", value: "rsabt-2-2"},
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INCORRECT_PASSWORD_ACCESS_TRIAL_REMOTE", value: "rsabt-2-3"},
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADMIN_MODE_USER_ACCESS_RSABT_LOCAL", value: "rsabt-2-4"},
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADMIN_MODE_USER_ACCESS_RSABT_END_LOCAL", value: "rsabt-2-5"},
      {	label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INCORRECT_PASSWORD_ACCESS_TRIAL_LOCAL", value: "rsabt-2-6"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.HIGH_OCCURRENCE",
    value: "rsabt-4",
    deviceType: "rsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ETH_LINK_PRESENCE_DETECTION", value: "rsabt-4-3"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ETH_LINK_LOST_DETECTION", value: "rsabt-4-4"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.NO_CARD_COMM_NO_CONSUMPTION_DETECTED", value: "rsabt-4-5"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.NO_CARD_COMM_CONSUMPTION_DETECTED", value: "rsabt-4-6"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CARD_STATUS_STEP_DETECTED_A_TF", value: "rsabt-4-7"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CARD_STATUS_STEP_DETECTED_TF_A", value: "rsabt-4-8"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SEND_WS_STG_FAILURE", value: "rsabt-4-16"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SEND_REPORT_FTP_STG_LINK_FAILURE", value: "rsabt-4-17"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SEND_REPORT_FTP_STG_INCORRECT_USER_PASS_FAILURE", value: "rsabt-4-18"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SEND_REPORT_FTP_STG_UNAVAILABLE_FTP_SERVICE_FAILURE", value: "rsabt-4-19"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.NO_COMM_WITH_NTP_SERVER_DETECTED", value: "rsabt-4-20"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.COMM_WITH_NTP_SERVER_DETECTED", value: "rsabt-4-21"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.RSABT_TSABT_REGISTER",
    value: "rsabt-5",
    deviceType: "rsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.REGISTERED_UNIQUE_ID_CARD", value: "rsabt-5-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.UNREGISTERED_UNIQUE_ID_CARD", value: "rsabt-5-2"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RTU_FIRST_CONFIG_REQUEST", value: "rsabt-5-3"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CARD_LINE_NUMBER_CHANGE_DETECTED", value: "rsabt-5-4"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.GROUND_FAULT",
    value: "rsabt-8",
    deviceType: "rsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_R", value: "rsabt-8-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_R_END", value: "rsabt-8-2"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_S", value: "rsabt-8-3"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_S_END", value: "rsabt-8-4"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_T", value: "rsabt-8-5"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GROUND_FAULT_DETECTION_PHASE_T_END", value: "rsabt-8-6"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.RSABT.GROUP.SUPPLY_QUALITY",
    value: "rsabt-9",
    deviceType: "rsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_R", value: "rsabt-9-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_R_END", value: "rsabt-9-2"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_S", value: "rsabt-9-3"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_S_END", value: "rsabt-9-4"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_T", value: "rsabt-9-5"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERRUPTION_DETECTION_PHASE_T_END", value: "rsabt-9-6"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_R", value: "rsabt-9-7"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_R_END", value: "rsabt-9-8"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_S", value: "rsabt-9-9"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_S_END", value: "rsabt-9-10"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_T", value: "rsabt-9-11"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.GAP_DETECTION_PHASE_T_END", value: "rsabt-9-12"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_R", value: "rsabt-9-13"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_R_END", value: "rsabt-9-14"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_S", value: "rsabt-9-15"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_S_END", value: "rsabt-9-16"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_T", value: "rsabt-9-17"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DETECTION_PHASE_T_END", value: "rsabt-9-18"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.THREE_PHASE_INTERRUPTION_END", value: "rsabt-9-19"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.THREE_PHASE_GAP_END", value: "rsabt-9-20"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.THREE_PHASE_OVERVOLTAGE_END", value: "rsabt-9-21"},
    ],
  },

  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.TSABT.GROUP.STANDARD",
    value: "tsabt-1",
    deviceType: "tsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.STARTUP_WITH_DATA_LOSS", value: "tsabt-1-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.STARTUP_WITHOUT_DATA_LOSS", value: "tsabt-1-2"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.INTERNAL_CRITICAL_ERROR", value: "tsabt-1-9"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_10", value: "tsabt-1-10"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_11", value: "tsabt-1-11"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_12", value: "tsabt-1-12"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_13", value: "tsabt-1-13"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_14", value: "tsabt-1-14"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_15", value: "tsabt-1-15"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_16", value: "tsabt-1-16"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_17", value: "tsabt-1-17"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_18", value: "tsabt-1-18"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_19", value: "tsabt-1-19"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_20", value: "tsabt-1-20"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_CHANGE_WINTER_SUMMER", value: "tsabt-1-24"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_CHANGE_SUMMER_WINTER", value: "tsabt-1-25"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.HIGH_TEMPERATURE", value: "tsabt-1-26"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.HIGH_TEMPERATURE_END", value: "tsabt-1-27"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CARD_CONFIG_CHANGE", value: "tsabt-1-30"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RS485_CONFIG_CHANGE", value: "tsabt-1-31"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PWD_CLIENT_READ", value: "tsabt-1-32"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PWD_CLIENT_MANAGEMENT", value: "tsabt-1-33"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PWD_CLIENT_FW", value: "tsabt-1-34"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADJUSTMENT_CHANGE_AUTO_UPDATE_SUMMER_TIME", value: "tsabt-1-36"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ADJUSTMENT_CHANGE_TRANSFORMATION_RELATION_V_I", value: "tsabt-1-39"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_CLOCK_SETTINGS", value: "tsabt-1-40"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PROGRAM_LABEL_CHANGED", value: "tsabt-1-41"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_PROFILE_1", value: "tsabt-1-66"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_PROFILE_2", value: "tsabt-1-67"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_PROFILE_3", value: "tsabt-1-68"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_PROFILE_4", value: "tsabt-1-69"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_PROFILE_5", value: "tsabt-1-70"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_RT", value: "tsabt-1-71"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_MID_VALUES", value: "tsabt-1-85"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_MAX_VALUES", value: "tsabt-1-86"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_MIN_VALUES", value: "tsabt-1-87"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_INSTANT_VALUES", value: "tsabt-1-88"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_INCREMENTAL_VALUES", value: "tsabt-1-89"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PERIOD_CHANGE_ACCUMULATED_VALUES", value: "tsabt-1-90"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FIRMWARE_CHANGED", value: "tsabt-1-97"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_SYNCHRONIZATION", value: "tsabt-1-98"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.DEFAULT_REGISTER_RESET", value: "tsabt-1-100"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.ERASE_DATA_PROFILES", value: "tsabt-1-101"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NOMINAL_VOLTAGE_B2", value: "tsabt-1-102"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NOMINAL_VOLTAGE_B1", value: "tsabt-1-103"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NOMINAL_CURRENT_PHASE_R", value: "tsabt-1-104"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NOMINAL_CURRENT_PHASE_S", value: "tsabt-1-105"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NOMINAL_CURRENT_PHASE_T", value: "tsabt-1-106"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_CURRENT_LIMIT_SHORTCIRCUIT", value: "tsabt-1-107"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_VOLTAGE_LIMIT_FUSE", value: "tsabt-1-108"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_CURRENT_LIMIT_OVERLOAD", value: "tsabt-1-109"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_TIME_LIMIT_FUSE_ACTIVATION", value: "tsabt-1-110"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_TIME_LIMIT_FUSE_DEACTIVATION", value: "tsabt-1-111"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_NULL_CURRENT_LIMIT_FUSE", value: "tsabt-1-112"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PERIOD_INTEGRATION_OVERLOAD", value: "tsabt-1-113"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_HYSTERESIS_SHORTCIRCUIT", value: "tsabt-1-114"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_HYSTERESIS_OVERLOAD", value: "tsabt-1-115"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.REF_VOLTAGE_ANOMALY", value: "tsabt-1-116"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_REF_CURRENT", value: "tsabt-1-117"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_OVERVOLTAGE_ACTIVATION_TIME", value: "tsabt-1-249"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_OVERVOLTAGE_DEACTIVATION_TIME", value: "tsabt-1-250"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_GAP_VOLTAGE_ACTIVATION_TIME", value: "tsabt-1-251"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_GAP_VOLTAGE_DEACTIVATION_TIME", value: "tsabt-1-252"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PERCENTAGE_OVERVOLTAGE", value: "tsabt-1-253"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CHANGE_PERCENTAGE_GAP_VOLTAGE", value: "tsabt-1-254"},
    ],
  },
    {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.TSABT.GROUP.SUPPLY_QUALITY",
    value: "tsabt-3",
    deviceType: "tsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_ACTIVATION_PHASE_R", value: "tsabt-3-26"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_DEACTIVATION_PHASE_R", value: "tsabt-3-27"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_ACTIVATION_PHASE_S", value: "tsabt-3-28"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_DEACTIVATION_PHASE_S", value: "tsabt-3-29"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_ACTIVATION_PHASE_T", value: "tsabt-3-30"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FUSE_DEACTIVATION_PHASE_T", value: "tsabt-3-31"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_ACTIVATION_PHASE_R", value: "tsabt-3-40"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_DEACTIVATION_PHASE_R", value: "tsabt-3-41"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_ACTIVATION_PHASE_S", value: "tsabt-3-42"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_DEACTIVATION_PHASE_S", value: "tsabt-3-43"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_ACTIVATION_PHASE_T", value: "tsabt-3-44"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SHORTCIRCUIT_DEACTIVATION_PHASE_T", value: "tsabt-3-45"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_ACTIVATION_PHASE_R", value: "tsabt-3-46"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_DEACTIVATION_PHASE_R", value: "tsabt-3-47"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_ACTIVATION_PHASE_S", value: "tsabt-3-48"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_DEACTIVATION_PHASE_S", value: "tsabt-3-49"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_ACTIVATION_PHASE_T", value: "tsabt-3-50"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERLOAD_DEACTIVATION_PHASE_T", value: "tsabt-3-51"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_ACTIVATION_PHASE_R", value: "tsabt-3-242"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DEACTIVATION_PHASE_R", value: "tsabt-3-243"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_ACTIVATION_PHASE_S", value: "tsabt-3-244"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DEACTIVATION_PHASE_S", value: "tsabt-3-245"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_ACTIVATION_PHASE_T", value: "tsabt-3-246"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_DEACTIVATION_PHASE_T", value: "tsabt-3-247"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_ACTIVATION_PHASE_R", value: "tsabt-3-248"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_DEACTIVATION_PHASE_R", value: "tsabt-3-249"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_ACTIVATION_PHASE_S", value: "tsabt-3-250"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_DEACTIVATION_PHASE_S", value: "tsabt-3-251"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_ACTIVATION_PHASE_T", value: "tsabt-3-252"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_GAP_DEACTIVATION_PHASE_T", value: "tsabt-3-253"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.TSABT.GROUP.HIGH_OCCURRENCE",
    value: "tsabt-6",
    deviceType: "tsabt",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.DLMS_ASSOCIATION_ESTABLISHED", value: "tsabt-6-5"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.DLMS_ASSOCIATION_FREE", value: "tsabt-6-6"},
    ],
  },


  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.VTN.GROUP.STANDARD",
    value: "vtn-1",
    deviceType: "vtn",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.REBOOT_WITH_LOSS_OF_DATA", value: " vtn-1-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.REBOOT_WITHOUT_LOSS_OF_DATA", value: " vtn-1-2"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.POWER_FAIL", value: " vtn-1-3"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CRITICAL_INTERNAL_ERROR", value: " vtn-1-9"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_10", value: " vtn-1-10"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_11", value: " vtn-1-11"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_12", value: " vtn-1-12"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_13", value: " vtn-1-13"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_14", value: " vtn-1-14"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_15", value: " vtn-1-15"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_16", value: " vtn-1-16"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_17", value: " vtn-1-17"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_18", value: " vtn-1-18"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_19", value: " vtn-1-19"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OTHER_ERRORS_20", value: " vtn-1-20"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OFFICIAL_CHANGE_LOCAL_TIME_WINTER_SUMMER", value: " vtn-1-24"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OFFICIAL_CHANGE_LOCAL_TIME_SUMMER_WINTER", value: " vtn-1-25"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVER_TEMPERATURE_ACTIVATION", value: " vtn-1-26"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVER_TEMPERATURE_CONDITION_END", value: " vtn-1-27"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.REGISTER_PARAMETERS_CHANGE", value: " vtn-1-30"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SERIAL_PORT_PARAMETERS_CHANGE", value: " vtn-1-31"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.READING_PASSWORD_CHANGE", value: " vtn-1-32"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.PARAMETERIZATION_PASSWORD_CHANGE", value: " vtn-1-33"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.FIRMWARE_PASSWORD_CHANGE", value: " vtn-1-34"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.BATTERY_CLEARED", value: " vtn-1-35"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.AUTO_DAYLIGHT_SAVING_TIME_CHANGE", value: " vtn-1-36"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.DATA_PROFILE_1_CAPTURE_PERIOD_CHANGE", value: " vtn-1-37"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.DATA_PROFILE_2_CAPTURE_PERIOD_CHANGE", value: " vtn-1-38"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.EVENT_FILTER_CHANGE", value: " vtn-1-39"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CLOCK_SETTINGS_CHANGED", value: " vtn-1-40"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.SOFTWARE_CHANGE", value: " vtn-1-97"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CLOCK_SYNCHRONIZATION", value: " vtn-1-98"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.RESET_ALL_CONFIG_TO_DEFAULT", value: " vtn-1-100"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.CLEAR_ALL_PROFILES", value: " vtn-1-101"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_THRESHOLD_OVERVOLTAGE_LEVEL1_CHANGED", value: " vtn-1-102"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.VOLTAGE_THRESHOLD_OVERVOLTAGE_LEVEL2_CHANGED", value: " vtn-1-103"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_THRESHOLD_OVERVOLTAGE_LEVEL1_ACTIVATION_CHANGED", value: " vtn-1-104"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_THRESHOLD_OVERVOLTAGE_LEVEL1_DEACTIVATION_CHANGED", value: " vtn-1-105"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_THRESHOLD_OVERVOLTAGE_LEVEL2_ACTIVATION_CHANGED", value: " vtn-1-106"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.TIME_THRESHOLD_OVERVOLTAGE_LEVEL2_DEACTIVATION_CHANGED", value: " vtn-1-107"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.VTN.GROUP.OVERVOLTAGE",
    value: "vtn-3",
    deviceType: "vtn",
    options: [
      {label:"FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_LEVEL1_ACTIVATION", value: "vtn-3-1"},
      {label:"FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_LEVEL1_DEACTIVATION", value: "vtn-3-2"},
      {label:"FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_LEVEL2_ACTIVATION", value: "vtn-3-3"},
      {label:"FILTERS.EVENT_GROUP_AND_TYPE.TYPE.OVERVOLTAGE_LEVEL2_DEACTIVATION", value: "vtn-3-4"},
    ],
  },
  {
    label: "FILTERS.EVENT_GROUP_AND_TYPE.DEVICE.VTN.GROUP.COMMON_FREQUENT_OCCURRENCE",
    value: "vtn-6",
    deviceType: "vtn",
    options: [
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.BEGIN_COMM_SERIAL_PORT", value: "vtn-6-1"},
      { label: "FILTERS.EVENT_GROUP_AND_TYPE.TYPE.END_COMM_SERIAL_PORT", value: "vtn-6-2"},
    ],
  },
]

export const NUMBER_FILTER_OPERATORS: SelectOption[] = [
  {
    label: 'FILTERS.NUMBER.GREATER_THAN',
    value: 'greaterThan'
  },
  {
    label: 'FILTERS.NUMBER.GREATER_THAN_EQUAL',
    value: 'greaterThanOrEqual'
  },
  {
    label: 'FILTERS.NUMBER.EQUAL_THAN',
    value: 'equals'
  },
  {
    label: 'FILTERS.NUMBER.LESS_THAN_EQUAL',
    value: 'lessThanOrEqual'
  },
  {
    label: 'FILTERS.NUMBER.LESS_THAN',
    value: 'lessThan'
  },
]

export const FILTER_CENTER_LOSSES: any = [
  {
    label: "FILTERS.FILTER_CENTER_LOSSES.ALL_CENTERS",
    value: "center",
    options: [
      { label: 'FILTERS.FILTER_CENTER_LOSSES.ALL_CENTERS', value: 'center-all'},
    ],
  },
  {
    label: "FILTERS.FILTER_CENTER_LOSSES.SECTOR",
    value: "sector",
    options: [
      { label: 'FILTERS.FILTER_CENTER_LOSSES.SECTOR_1', value: 'sector-1'},
      { label: 'FILTERS.FILTER_CENTER_LOSSES.SECTOR_2', value: 'sector-2'},
      { label: 'FILTERS.FILTER_CENTER_LOSSES.SECTOR_3', value: 'sector-3'},
      { label: 'FILTERS.FILTER_CENTER_LOSSES.SECTOR_4', value: 'sector-4'},
    ],
  },
  {
    label: "FILTERS.FILTER_CENTER_LOSSES.MUNICIPALITY",
    value: "municipality",
    options: [
      { label: 'FILTERS.FILTER_CENTER_LOSSES.MUNICIPALITY', value: 'municipality-all'},
    ],
  },
  {
    label: "FILTERS.FILTER_CENTER_LOSSES.ZONE",
    value: "zone",
    options: [
      { label: 'FILTERS.FILTER_CENTER_LOSSES.ZONE', value: 'zone-all'},
    ],
  },
]

export const WHERE_LOSSES: FilterConfig[] = [
  {
    label: 'FILTERS.WHERE_LOSSES.SECTOR',
    value: 'sector',
    type: 'select',
    options: []
  },
  {
    label: 'FILTERS.WHERE_LOSSES.MUNICIPALITY',
    value: 'town',
    type: 'select',
    options: []
  },
  {
    label: 'FILTERS.WHERE_LOSSES.CENTER',
    value: 'center',
    type: 'select',
    options: []
  },
  {
    label: 'FILTERS.WHERE_LOSSES.ZONE',
    value: 'zone',
    type: 'select',
    options: []
  },
]

export const SYMBOLS_FILTER_OPERATORS: SelectOption[] = [
  {
    label: 'FILTERS.SYMBOLS.GREATER_THAN',
    value: 'more'
  },
  {
    label: 'FILTERS.SYMBOLS.GREATER_THAN_EQUAL',
    value: 'moreEquals'
  },
  {
    label: 'FILTERS.SYMBOLS.LESS_THAN_EQUAL',
    value: 'lessEquals'
  },
  {
    label: 'FILTERS.SYMBOLS.LESS_THAN',
    value: 'less'
  },
]

export const VALUE_PERCENTAGE: SelectOption[]= [
  {
    label: 'FILTERS.VALUE_PERCENTAGE.TRUE',
    value: 'true'
  },
  {
    label: 'FILTERS.VALUE_PERCENTAGE.FALSE',
    value: 'false'
  },
]

export const DURATIONS_UNITS: SelectOption[] = [
  {
    label: 'FILTERS.DURATION.MINUTE',
    value: 'minute'
  },
  {
    label: 'FILTERS.DURATION.HOUR',
    value: 'hour'
  },
]

export const REFERENCE_VALUE_UNITS: SelectOption[] = [
  {
    label: 'FILTERS.REFERENCE_VALUE.HERTZ',
    value: 'hz'
  },
  {
    label: 'FILTERS.REFERENCE_VALUE.VOLTIOS',
    value: 'v'
  },
  {
    label: 'FILTERS.REFERENCE_VALUE.AMPERE',
    value: 'a'
  },
  {
    label: 'FILTERS.REFERENCE_VALUE.CELSIUS',
    value: 'C'
  },
]

export const PRIORITY: SelectOption[] = [
  {
    label: 'PRIORITY.HIGH',
    value: 'high'
  },
  {
    label: 'PRIORITY.MEDIUM',
    value: 'medium'
  },
  {
    label: 'PRIORITY.LOW',
    value: 'low'
  },
]

export const ALARMS_FILTERS: any[] = [
  {
    label: 'FILTERS.ALARM_CATEGORY_AND_TYPE.ALARM_TYPE',
    value: 'deviceType-alarmCategory-alarmType',
    type: 'selectGroup',
    condition: 'equals',
    options: ALARM_CATEGORY_AND_TYPE
  },
];

export const EVENTS_FILTERS: any[] = [
  {
    label: 'FILTERS.EVENT_GROUP_AND_TYPE.EVENT_TYPE',
    value: 'deviceType-eventGroupId-eventTypeId',
    type: 'selectGroup',
    condition: 'equals',
    options: EVENT_GROUP_AND_TYPE
  },
];
